var _circle, _circle2, _circle3, _path, _path2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCoin = function SvgCoin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    fill: "none",
    viewBox: "0 0 25 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.48,
    cy: 13.404,
    r: 12.48,
    fill: "#926E4F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.48,
    cy: 12.48,
    r: 12.48,
    fill: "url(#paint0_linear)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.48,
    cy: 12.48,
    r: 11.296,
    stroke: "url(#paint1_linear)",
    strokeWidth: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.244 6.471c1.532 0 2.774 1.242 2.774 2.773 0 1.532-1.242 2.774-2.774 2.774-1.531 0-2.773-1.242-2.773-2.774 0-1.531 1.242-2.773 2.773-2.773z",
    clipRule: "evenodd",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.716 6.471c1.531 0 2.773 1.242 2.773 2.773 0 1.532-1.242 2.774-2.773 2.774-1.532 0-2.774-1.242-2.774-2.774 0-1.531 1.242-2.773 2.774-2.773zM9.244 12.942c1.532 0 2.774 1.242 2.774 2.774 0 1.531-1.242 2.773-2.774 2.773-1.531 0-2.773-1.242-2.773-2.774 0-1.531 1.242-2.773 2.773-2.773z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.547,
    x2: -2.547,
    y1: -5.095,
    y2: 24.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.924,
    x2: 0.924,
    y1: 0.924,
    y2: 24.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD8F6C"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coin.6f18cdfa.svg";
export { ForwardRef as ReactComponent };